import { CustomerService, CustomerError } from '@/services/customer.service'
import { CUSTOMER_REQUEST } from './actions'

const state = {
  customers: [],
  count: 0
}

const getters = {
  customerList: state =>
    state.customers.filter(v => !!v.location && !!v.location.lat),
  customerCount: state => state.count
}

const actions = {
  async [CUSTOMER_REQUEST]({ commit }, filter) {
    // console.log('CUSTOMER_REQUEST')
    // console.log(filter)

    if (!filter.showCustomers) {
      commit(CUSTOMER_REQUEST, [], 0)
      return
    }

    const f = {
      categories: filter.categories,
      payment: filter.payment,
      status: ['SEARCHING', 'SELLING', 'HAPPY']
    }

    // if (filter.price[0]) f.price__gt = filter.price[0]
    // if (filter.price[1]) f.price__lt = filter.price[1]
    // if (filter.bedrooms > 0) f.bedrooms__gt = filter.bedrooms - 1
    // if (filter.bathrooms > 0) f.bathrooms__gt = filter.bathrooms - 1
    // filter.filterOptions.properties.forEach(v => {
    //   if (v.value) f[v.name] = true
    //   else delete f[v.name]
    // })

    // console.log(f)

    try {
      const { customers, count } = await CustomerService.getCustomers(f)
      commit(CUSTOMER_REQUEST, customers, count)
    } catch (e) {
      if (e instanceof CustomerError) {
        console.log(e)
      }
      return false
    }
  }
}

const mutations = {
  [CUSTOMER_REQUEST]: (state, customers, count) => {
    state.customers = customers
    state.count = count
    // console.table(state.customers)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
